<template>
  <div id="right-2">
    <div class="area-title">
      <span>每日订单与用电量</span>
    </div>
    <div class="area-padding" ref="rightCenter">
    </div>
  </div>
</template>
<script>
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timer: null,
      rightCenterChart: null,
      timesList: [],
      orderNumList: [],
      elecTotalList: [],
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    this.timer = setInterval(() => {
      setTimeout(this.getData(), 0);
    }, 1000 * 30);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 初始化echarts实例对象
    initChart() {
      this.rightCenterChart = this.$echarts.init(this.$refs.rightCenter);
    },
    getData() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/dailyOrderNum"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: this.deviceType,
          regionId: this.regionId,
          level: this.level,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.timesList = data.data.timesList;
          this.orderNumList = data.data.orderNumList;
          this.elecTotalList = data.data.elecTotalList;
          this.updateChart();
        }
      });
    },
    // 更新图表
    updateChart() {
      const option = {
        legend: {
          textStyle: {
            color: "#B4B4B4",
          },
          top: "5%",
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "10%",
          top: "20%",
          containLabel: true,
        },
        xAxis: {
          data: this.timesList,
          axisLine: {
            lineStyle: {
              color: "#B4B4B4",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            // name: "个",
            type: "value",
            splitLine: { show: false },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#B4B4B4",
              },
            },
          },
        ],
        series: [
          {
            name: "订单数(个)",
            type: "line",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            // yAxisIndex: 0,
            symbol: "emptyCircle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#6DD400",
              },
            },
            lineStyle: {
              normal: {
                color: "#6DD400",
                width: 3,
              },
            },
            areaStyle: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(48, 188, 116, 0.51)",
                },
                {
                  offset: 1,
                  color: "rgba(48, 188, 116, 0.03)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.orderNumList,
          },
          {
            name: "用电量(度)",
            type: "line",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            // yAxisIndex: 1,
            symbol: "emptyCircle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#00ECFC",
              },
            },
            lineStyle: {
              normal: {
                // color: this.colorList.linearBtoG,
                color: "#00ECFC",
                width: 3,
              },
            },
            areaStyle: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(0, 236, 252, 0.51)",
                },
                {
                  offset: 1,
                  color: "rgba(138, 248, 255, 0.03)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.elecTotalList,
          },
        ],
      };
      this.rightCenterChart.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
#right-2 {
  width: 100%;
  height: 288px;
  // border: 1px solid red;
  margin: 36px 0;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }
  .area-padding {
    // padding: 0 16px;
    width: 100%;
    height: 288px;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/right-2.vue